import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import IPTVSubDevices from "./IPTVSubscriptionDevices";
import CustomizedActions from "./BulkActions";
import Checkbox from "@mui/material/Checkbox";


import { API_URL } from "../components/api";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import AuthContext from "../context/AuthContext";
import axios from "axios";
import ExcelSVG from "../../ExcelSVG.svg";
import * as XLSX from "xlsx";
import Button from "react-bootstrap/Button";

function IPTVTable() {
  const [data, setData] = useState([]);
  const [showo, setShowo] = useState(false);
  const [showAddon, setShowAddon] = useState(false);
  const [showSub, setShowSub] = useState(false);
  const [checkedRows, setCheckedRows] = useState([]);

  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const { user } = useContext(AuthContext);
  const [DealerDetails, setDealerDetails] = useState({
    name: "",
    notes: "",
    plan: "",
    expiry: "",
    code: "",
    password: "",
    iptv_id: "",
  });

  const handleshowo = () => setShowo(true);
  const handleedit = () => setShowo(false);

  // ADDON  ✅ use showAddon state
  const handleshowAddon = () => setShowAddon(true);
  const handlecloseAddon = () => setShowAddon(false);

  // SUBS   ✅ use showSub state
  const handleShowSub = () => setShowSub(true);
  const handleCloseSub = () => setShowSub(false);

  const updateDealerDetails = (details) => {
    console.log("Updating DealerDetails:", details); // Debugging log
    setDealerDetails(details);
  };

  const [filters, setFilters] = useState({
    name: "",
    notes: "",
    plan: "",
    expiry: "",
    iptv_id: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filteredRowsData, setFilteredRowsData] = useState([]); // State to store filtered rows
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(
          `${API_URL}/radius/subscriptions/iptv/subscriptions/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
            },
          }
        );

        if (response.status === 200) {
          setData(response.data);
          console.log("Fetched data:", response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user.username]);
  const handleDeselectCheckboxes = () => setCheckedRows([]);

  const handleCheckboxChange = (event, subscriptionId) => {
    const checked = event.target.checked;
    setCheckedRows((prev) =>
      checked ? [...prev, subscriptionId] : prev.filter((id) => id !== subscriptionId)
    );
  };
  const columns = [
     {
    field: "checkbox",
    headerName: "",
    width: 80,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <Checkbox
        className="subcheck"
        checked={checkedRows.includes(params.id)}
        onChange={(event) => handleCheckboxChange(event, params.id)}
        onClick={(e) => e.stopPropagation()} // prevent row click side-effects
      />
    ),
  },
    { field: "status", headerName: "Status", flex: 2, minWidth: 50 },
    { field: "clients_name", headerName: "Name", flex: 2, minWidth: 50 },
    { field: "name", headerName: "IPTV Account", flex: 2, minWidth: 50 },
    { field: "username", headerName: "Username", flex: 2, minWidth: 50 },
    {
      field: "creation_date",
      headerName: "Creation",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const dateString = params.value;
        // Parse the ISO 8601 format string
        const date = new Date(dateString);

        // Extract day, month, and year
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();

        // Format the date as dd-mm-yyyy
        return `${day}-${month}-${year}`;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 200,
      flex: 2,
      renderCell: (params) => (
        <div>
          <button
            className="edit-client"
            onClick={() => {
              console.log("Row data:", params.row); // Debugging log
              const details = {
                iptv_id: params.row.iptv_subscription_id,
              };
              updateDealerDetails(details);
              handleShowSub();
            }}
          >
            Devices
          </button>
        </div>
      ),
    },
  ];

  const getRowId = (row) => row.iptv_subscription_id;
  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchSubscriptionServices");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchSubscriptionServices") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchSubscriptionServices", searchValue);
      setSearchQuery(searchValue);
    }
  }, []);

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    sessionStorage.setItem("searchSubscriptionServices", query);
  };

  const handleFilterChange = (field, value) => {
    // Update filters state
    setFilters((prevFilters) => {
      const newFilters = {
        ...prevFilters,
        [field]: value,
      };

      // Apply all active filters to get new filtered data
      const newFilteredData = data.filter((row) => {
        // Apply modal filters
        const modalFilterMatch = Object.keys(newFilters).every((key) => {
          if (!newFilters[key]) return true; // Skip empty filters
          const rowValue = String(row[key] || "").toLowerCase();
          const filterValue = String(newFilters[key]).toLowerCase();
          return rowValue.includes(filterValue);
        });

        // Apply search query filter
        const searchMatch = searchQuery
          .split(" ")
          .every((word) =>
            Object.values(row).some((value) =>
              String(value).toLowerCase().includes(word.toLowerCase().trim())
            )
          );

        // Apply DataGrid filters
        const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
          if (!filterItem.value) return true;

          const cellValue = row[filterItem.field];
          const filterValue = filterItem.value;

          switch (filterItem.operator) {
            case "contains":
              return String(cellValue)
                .toLowerCase()
                .includes(String(filterValue).toLowerCase());
            case "equals":
              return String(cellValue) === String(filterValue);
            case "startsWith":
              return String(cellValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase());
            case "endsWith":
              return String(cellValue)
                .toLowerCase()
                .endsWith(String(filterValue).toLowerCase());
            default:
              return true;
          }
        });

        return searchMatch && modalFilterMatch && gridFilterMatch;
      });

      // Update filteredRowsData with new filtered results
      setFilteredRowsData(newFilteredData);

      return newFilters;
    });
  };

  // Combined filtering logic
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true; // Skip empty filters
      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue)
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue) === String(filterValue);
        case "startsWith":
          return String(cellValue)
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue)
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    // Return true only if all filters match
    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  // Define the column headers mapping
  const columnHeaders = {
    status: "Status",
    username: "Username",
    fullname_en: "Client",
    name: "Service",
    description: "Description",
    selling_price: "Price",
  };

  // Function to transform the rows based on columnHeaders
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};
      Object.keys(columnHeaders).forEach((key) => {
        transformedRow[columnHeaders[key]] = row[key];
      });
      return transformedRow;
    });
  };

  const handleExportToExcel = () => {
    // Transform the rows to match the new column headers
    const transformedRows =
      filteredRowsData.length > 0
        ? transformRowsForExport(filteredRowsData)
        : transformRowsForExport(filteredRows);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscription Services");
    XLSX.writeFile(workbook, "Subscription Service.xlsx");
  };
  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    // Optional: Reset the button state after a short delay
    setTimeout(() => {
      setIsPressed(false);
    }, 200); // Adjust the timeout as needed
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent", // Change background on press
          color: isPressed ? "black" : "#007bff", // Change text color on press
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)", // Make the SVG white or retain its original color
          }}
        />
        Excel
      </Button>
      <Button
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
      >
        Filter
      </Button>
    </GridToolbarContainer>
  );

  return (
    <div className="ClientTable">
      <div className="actions">
        <CustomizedActions subscriptions={checkedRows} deselect={handleDeselectCheckboxes} />

      </div>
      <input
        type="text"
        placeholder="Search..."
        value={searchQuery}
        onChange={handleSearch}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRowsData.length > 0 ? filteredRowsData : data}
            columns={columns}
            getRowId={getRowId}
            components={{ Toolbar: CustomToolbar }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) =>
              setGridFilterModel(newModel) || handleFilterChange
            }
          />
        </div>
      )}
      
     
      <Modal show={showSub} onHide={handleCloseSub}>
        <Modal.Header closeButton>
          <Modal.Title>Devices</Modal.Title>
        </Modal.Header>
        <IPTVSubDevices iptv_id={DealerDetails.iptv_id} />
      </Modal>

      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {columns
            .filter((col) => col.field !== "actions")
            .map((col) => (
              <div key={col.field} className="filter">
                <label>{col.headerName}</label>
                <input
                  type="text"
                  placeholder={`Filter by ${col.headerName}`}
                  value={filters[col.field] || ""}
                  onChange={(e) =>
                    handleFilterChange(col.field, e.target.value)
                  }
                  className="filter-input"
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default IPTVTable;
